"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _excluded = ["size", "fill"];

var _default = function _default(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? '20' : _ref$size,
      _ref$fill = _ref.fill,
      fill = _ref$fill === void 0 ? '#24292E' : _ref$fill,
      restProps = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement("svg", (0, _extends2["default"])({
    width: size,
    height: size,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, restProps), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M13.3336 7.50008V5.00008C13.3336 3.15913 11.8412 1.66675 10.0003 1.66675C8.15932 1.66675 6.66693 3.15913 6.66693 5.00008V7.50008M2.9936 8.62672L2.4936 13.96C2.35144 15.4765 2.28036 16.2347 2.53198 16.8203C2.75302 17.3348 3.14037 17.7601 3.63195 18.0282C4.19154 18.3334 4.95307 18.3334 6.47614 18.3334H13.5244C15.0475 18.3334 15.809 18.3334 16.3686 18.0282C16.8602 17.7601 17.2475 17.3348 17.4686 16.8203C17.7202 16.2347 17.6491 15.4765 17.5069 13.9601L17.0069 8.62672C16.8869 7.3462 16.8269 6.70594 16.5389 6.22188C16.2853 5.79557 15.9105 5.45434 15.4624 5.24162C14.9536 5.00008 14.3105 5.00008 13.0244 5.00008L6.97614 5.00008C5.69001 5.00008 5.04694 5.00008 4.53812 5.24162C4.08999 5.45434 3.71527 5.79557 3.46165 6.22188C3.17368 6.70594 3.11365 7.3462 2.9936 8.62672Z",
    stroke: fill,
    strokeWidth: "1.66667",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};

exports["default"] = _default;